var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"navbar__item",class:{
        'navbar__item--icon': _vm.itemStyle == 'icon',
        'navbar__item--list': _vm.itemStyle == 'list',
        'navbar__item--active': _vm.item.active
    },attrs:{"id":_vm.item.id}},[_c('a',{attrs:{"href":_vm.item.link}},[_c('i',{class:_vm.item.class}),_c('div',[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }